import { render, staticRenderFns } from "./UiBecomeCreatorModal.vue?vue&type=template&id=c79c6300&"
import script from "./UiBecomeCreatorModal.vue?vue&type=script&lang=js&"
export * from "./UiBecomeCreatorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports